<template>
    <header class="z-10 py-4 bg-white shadow-md dark:bg-gray-800">
        <div
            class="container flex items-center justify-between h-full px-6 mx-auto text-gray-600 dark:text-gray-300"
        >
            <!-- Mobile hamburger -->
            <button
                id="toggleMenuButton"
                class="p-1 mr-5 -ml-1 rounded-md md:hidden focus:outline-none focus:shadow-outline-red"
                @click.prevent="toggleSideMenu()"
                aria-label="Menu"
            >
                <svg
                    class="w-6 h-6"
                    aria-hidden="true"
                    fill="currentColor"
                    viewBox="0 0 20 20"
                >
                    <path
                        fill-rule="evenodd"
                        d="M3 5a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1zM3 10a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1zM3 15a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1z"
                        clip-rule="evenodd"
                    ></path>
                </svg>
            </button>
            <!-- Search input -->
            <div class="flex justify-center flex-1 lg:mr-32">
                <div
                    class="relative w-full max-w-xl mr-6 focus-within:text-gray-500"
                >
                    <div class="absolute inset-y-0 flex items-center pl-2">
                        <svg
                            class="w-4 h-4"
                            aria-hidden="true"
                            fill="currentColor"
                            viewBox="0 0 20 20"
                        >
                            <path
                                fill-rule="evenodd"
                                d="M8 4a4 4 0 100 8 4 4 0 000-8zM2 8a6 6 0 1110.89 3.476l4.817 4.817a1 1 0 01-1.414 1.414l-4.816-4.816A6 6 0 012 8z"
                                clip-rule="evenodd"
                            ></path>
                        </svg>
                    </div>
                    <input
                        class="w-full pl-8 pr-2 text-sm text-gray-700 dark:text-gray-400 placeholder-gray-600 bg-gray-100 border-0 rounded-md dark:placeholder-gray-500 dark:focus:shadow-outline-gray dark:focus:placeholder-gray-600 dark:bg-gray-700 dark:text-gray-200 focus:placeholder-gray-500 focus:bg-white focus:border-red-300 focus:outline-none focus:shadow-outline-red form-input"
                        type="text"
                        placeholder="Search for projects"
                        aria-label="Search"
                    />
                </div>
            </div>
            <ul class="flex items-center flex-shrink-0 space-x-6">
                <!-- Theme toggler -->
                <li class="flex">
                    <button
                        class="rounded-md focus:outline-none focus:shadow-outline-red text-red-600"
                        @click="toggleTheme"
                        aria-label="Toggle color mode"
                    >
                        <template v-if="!dark">
                            <svg
                                class="w-5 h-5"
                                aria-hidden="true"
                                fill="currentColor"
                                viewBox="0 0 20 20"
                            >
                                <path
                                    d="M17.293 13.293A8 8 0 016.707 2.707a8.001 8.001 0 1010.586 10.586z"
                                ></path>
                            </svg>
                        </template>
                        <template v-if="dark">
                            <svg
                                class="w-5 h-5"
                                aria-hidden="true"
                                fill="currentColor"
                                viewBox="0 0 20 20"
                            >
                                <path
                                    fill-rule="evenodd"
                                    d="M10 2a1 1 0 011 1v1a1 1 0 11-2 0V3a1 1 0 011-1zm4 8a4 4 0 11-8 0 4 4 0 018 0zm-.464 4.95l.707.707a1 1 0 001.414-1.414l-.707-.707a1 1 0 00-1.414 1.414zm2.12-10.607a1 1 0 010 1.414l-.706.707a1 1 0 11-1.414-1.414l.707-.707a1 1 0 011.414 0zM17 11a1 1 0 100-2h-1a1 1 0 100 2h1zm-7 4a1 1 0 011 1v1a1 1 0 11-2 0v-1a1 1 0 011-1zM5.05 6.464A1 1 0 106.465 5.05l-.708-.707a1 1 0 00-1.414 1.414l.707.707zm1.414 8.486l-.707.707a1 1 0 01-1.414-1.414l.707-.707a1 1 0 011.414 1.414zM4 11a1 1 0 100-2H3a1 1 0 000 2h1z"
                                    clip-rule="evenodd"
                                ></path>
                            </svg>
                        </template>
                    </button>
                </li>
                <!-- Notifications menu -->
<!--                <li class="relative" ref="notificationMenu">-->
<!--                    <button-->
<!--                        class="relative align-middle rounded-md focus:outline-none focus:shadow-outline-purple"-->
<!--                        @click="toggleNotificationsMenu"-->
<!--                        @keydown.esc="closeNotificationsMenu"-->
<!--                        aria-label="Notifications"-->
<!--                        aria-haspopup="true"-->
<!--                    >-->
<!--                        <svg-->
<!--                            class="w-5 h-5"-->
<!--                            aria-hidden="true"-->
<!--                            fill="currentColor"-->
<!--                            viewBox="0 0 20 20"-->
<!--                        >-->
<!--                            <path-->
<!--                                d="M10 2a6 6 0 00-6 6v3.586l-.707.707A1 1 0 004 14h12a1 1 0 00.707-1.707L16 11.586V8a6 6 0 00-6-6zM10 18a3 3 0 01-3-3h6a3 3 0 01-3 3z"-->
<!--                            ></path>-->
<!--                        </svg>-->
<!--                        &lt;!&ndash; Notification badge &ndash;&gt;-->
<!--                        <span-->
<!--                            aria-hidden="true"-->
<!--                            class="absolute top-0 right-0 inline-block w-3 h-3 transform translate-x-1 -translate-y-1 bg-red-600 border-2 border-white rounded-full dark:border-gray-800"-->
<!--                        ></span>-->
<!--                    </button>-->
<!--                    <transition enter-active-class="transition ease-in-out duration-150"-->
<!--                                enter-from-class="opacity-0"-->
<!--                                enter-to-class="opacity-100"-->
<!--                                leave-active-class="transition ease-in-out duration-150"-->
<!--                                leave-from-class="opacity-100"-->
<!--                                leave-to-class="opacity-0"-->
<!--                    >-->
<!--                        <ul v-show="isNotificationsMenuOpen"-->
<!--                            @keydown.esc="closeNotificationsMenu"-->
<!--                            class="absolute right-0 w-56 p-2 mt-2 space-y-2 text-gray-600 bg-white border border-gray-100 rounded-md shadow-md dark:text-gray-300 dark:border-gray-700 dark:bg-gray-700"-->
<!--                        >-->
<!--                            <li class="flex">-->
<!--                                <inertia-link class="inline-flex items-center justify-between w-full px-2 py-1 text-sm font-semibold transition-colors duration-150 rounded-md hover:bg-gray-100 hover:text-gray-800 dark:hover:bg-gray-800 dark:hover:text-gray-200"-->
<!--                                   href="#"-->
<!--                                >-->
<!--                                    <span>Messages</span>-->
<!--                                    <span-->
<!--                                        class="inline-flex items-center justify-center px-2 py-1 text-xs font-bold leading-none text-red-600 bg-red-100 rounded-full dark:text-red-100 dark:bg-red-600"-->
<!--                                    >-->
<!--                                      13-->
<!--                                    </span>-->
<!--                                </inertia-link>-->
<!--                            </li>-->
<!--                            <li class="flex">-->
<!--                                <inertia-link class="inline-flex items-center justify-between w-full px-2 py-1 text-sm font-semibold transition-colors duration-150 rounded-md hover:bg-gray-100 hover:text-gray-800 dark:hover:bg-gray-800 dark:hover:text-gray-200"-->
<!--                                   href="#"-->
<!--                                >-->
<!--                                    <span>Sales</span>-->
<!--                                    <span-->
<!--                                        class="inline-flex items-center justify-center px-2 py-1 text-xs font-bold leading-none text-red-600 bg-red-100 rounded-full dark:text-red-100 dark:bg-red-600"-->
<!--                                    >-->
<!--                                      2-->
<!--                                    </span>-->
<!--                                </inertia-link>-->
<!--                            </li>-->
<!--                            <li class="flex">-->
<!--                                <inertia-link class="inline-flex items-center justify-between w-full px-2 py-1 text-sm font-semibold transition-colors duration-150 rounded-md hover:bg-gray-100 hover:text-gray-800 dark:hover:bg-gray-800 dark:hover:text-gray-200"-->
<!--                                   href="#"-->
<!--                                >-->
<!--                                    <span>Alerts</span>-->
<!--                                </inertia-link>-->
<!--                            </li>-->
<!--                        </ul>-->
<!--                    </transition>-->
<!--                </li>-->
                <!-- Teams menu -->
                <li class="relative text-gray-500 dark:text-gray-400" ref="teamsMenu" v-if="$page.props.jetstream.hasTeamFeatures">
                    <button
                        class="inline-flex items-center px-3 py-2 border border-transparent text-sm leading-4 font-medium rounded-md hover:text-gray-800 dark:hover:text-gray-200 focus:outline-none transition"
                        @click="toggleTeamsMenu"
                        @keydown.esc="closeTeamsMenu"
                        aria-label="Notifications"
                        aria-haspopup="true"
                    >
                        {{ $page.props.auth.user.current_team.name }}

                        <svg class="ml-2 -mr-0.5 h-4 w-4" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor">
                            <path fill-rule="evenodd" d="M10 3a1 1 0 01.707.293l3 3a1 1 0 01-1.414 1.414L10 5.414 7.707 7.707a1 1 0 01-1.414-1.414l3-3A1 1 0 0110 3zm-3.707 9.293a1 1 0 011.414 0L10 14.586l2.293-2.293a1 1 0 011.414 1.414l-3 3a1 1 0 01-1.414 0l-3-3a1 1 0 010-1.414z" clip-rule="evenodd" />
                        </svg>
                    </button>
                    <transition enter-active-class="transition ease-in-out duration-150"
                                enter-from-class="opacity-0"
                                enter-to-class="opacity-100"
                                leave-active-class="transition ease-in-out duration-150"
                                leave-from-class="opacity-100"
                                leave-to-class="opacity-0"
                    >
                        <ul v-show="isTeamsMenuOpen"
                            @keydown.esc="closeTeamsMenu"
                            class="absolute right-0 w-56 p-2 mt-2 space-y-2 text-gray-600 bg-white border border-gray-100 rounded-md shadow-md dark:text-gray-300 dark:border-gray-700 dark:bg-gray-700"
                        >
                            <li class="flex px-2 py-2 text-xs text-gray-400">
                                Manage Team
                            </li>
                            <li class="flex">
                                <inertia-link class="inline-flex items-center justify-between w-full px-2 py-1 text-sm font-semibold transition-colors duration-150 rounded-md hover:bg-gray-100 hover:text-gray-800 dark:hover:bg-gray-800 dark:hover:text-gray-200"
                                   :href="route('teams.show', $page.props.auth.user.current_team)"
                                >
                                    <span>Team Settings</span>
                                </inertia-link>
                            </li>
                            <li class="flex" v-if="$page.props.jetstream.canCreateTeams">
                                <inertia-link class="inline-flex items-center justify-between w-full px-2 py-1 text-sm font-semibold transition-colors duration-150 rounded-md hover:bg-gray-100 hover:text-gray-800 dark:hover:bg-gray-800 dark:hover:text-gray-200"
                                   :href="route('teams.create')"
                                >
                                    <span>Create New Team</span>
                                </inertia-link>
                            </li>
                            <li class="border-t border-gray-100 dark:border-gray-600"></li>
                            <li class="flex px-2 py-2 text-xs text-gray-400">
                                Switch Teams
                            </li>
                            <template v-for="team in $page.props.auth.user.all_teams" :key="team.id">
                                <form @submit.prevent="switchToTeam(team)">
                                    <li class="flex">
                                        <button class="inline-flex items-center justify-between w-full px-2 py-1 text-sm font-semibold transition-colors duration-150 rounded-md hover:bg-gray-100 hover:text-gray-800 dark:hover:bg-gray-800 dark:hover:text-gray-200">
                                            <div class="flex items-center">
                                                <svg v-if="team.id === $page.props.auth.user.current_team_id" class="mr-2 h-5 w-5 text-green-400" fill="none" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" stroke="currentColor" viewBox="0 0 24 24"><path d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"></path></svg>
                                                <div>{{ team.name }}</div>
                                            </div>
                                        </button>
                                    </li>
                                </form>
                            </template>
                        </ul>
                    </transition>
                </li>
                <!-- Profile menu -->
                <li class="relative text-gray-500 dark:text-gray-400" ref="profileMenu">
                    <button
                        class="align-middle rounded-full focus:shadow-outline-red focus:outline-none"
                        @click="toggleProfileMenu"
                        @keydown.esc="closeProfileMenu"
                        aria-label="Account"
                        aria-haspopup="true"
                    >
                        <img v-if="$page.props.jetstream.managesProfilePhotos"
                             class="object-cover w-8 h-8 rounded-full"
                             :src="$page.props.auth.user.profile_photo_url" :alt="$page.props.auth.user.name"
                             aria-hidden="true"
                        />
                        <span v-else class="inline-flex rounded-md">
                            <button type="button" class="inline-flex items-center px-3 py-2 border border-transparent text-sm leading-4 font-medium rounded-md hover:text-gray-800 dark:hover:text-gray-200 focus:outline-none transition">
                                {{ $page.props.auth.user.name }}

                                <svg class="ml-2 -mr-0.5 h-4 w-4" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor">
                                    <path fill-rule="evenodd" d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z" clip-rule="evenodd" />
                                </svg>
                            </button>
                        </span>
                    </button>
                    <transition enter-active-class="transition ease-in-out duration-150"
                                enter-from-class="opacity-0"
                                enter-to-class="opacity-100"
                                leave-active-class="transition ease-in-out duration-150"
                                leave-from-class="opacity-100"
                                leave-to-class="opacity-0"
                    >
                        <ul v-if="isProfileMenuOpen"
                            @keydown.esc="closeProfileMenu"
                            class="absolute right-0 w-56 p-2 mt-2 space-y-2 text-gray-600 bg-white border border-gray-100 rounded-md shadow-md dark:border-gray-700 dark:text-gray-300 dark:bg-gray-700"
                            aria-label="submenu"
                        >
                            <li class="flex px-2 py-2 text-xs text-gray-400">
                                Manage Account
                            </li>
                            <li class="flex">
                                <inertia-link
                                    class="inline-flex items-center w-full px-2 py-1 text-sm font-semibold transition-colors duration-150 rounded-md hover:bg-gray-100 hover:text-gray-800 dark:hover:bg-gray-800 dark:hover:text-gray-200"
                                    :href="route('profile.show')"
                                >
                                    <svg
                                        class="w-4 h-4 mr-3"
                                        aria-hidden="true"
                                        fill="none"
                                        stroke-linecap="round"
                                        stroke-linejoin="round"
                                        stroke-width="2"
                                        viewBox="0 0 24 24"
                                        stroke="currentColor"
                                    >
                                        <path
                                            d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z"
                                        ></path>
                                    </svg>
                                    <span>Profile</span>
                                </inertia-link>
                            </li>
                            <li class="flex" v-if="$page.props.jetstream.hasApiFeatures">
                                <inertia-link
                                    class="inline-flex items-center w-full px-2 py-1 text-sm font-semibold transition-colors duration-150 rounded-md hover:bg-gray-100 hover:text-gray-800 dark:hover:bg-gray-800 dark:hover:text-gray-200"
                                    :href="route('api-tokens.index')"
                                >
                                    <svg class="w-4 h-4 mr-3"
                                         aria-hidden="true"
                                         fill="none"
                                         stroke-linecap="round"
                                         stroke-linejoin="round"
                                         stroke-width="2"
                                         viewBox="0 0 24 24"
                                         stroke="currentColor"
                                    >
                                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                              d="M15 7a2 2 0 012 2m4 0a6 6 0 01-7.743 5.743L11 17H9v2H7v2H4a1 1 0 01-1-1v-2.586a1 1 0 01.293-.707l5.964-5.964A6 6 0 1121 9z"></path>
                                    </svg>
                                    <span>API Tokens</span>
                                </inertia-link>
                            </li>
                            <li class="border-t border-gray-100 dark:border-gray-600"></li>
                            <form method="POST" @submit.prevent="logout">
                                <li class="flex">
                                    <button
                                        class="inline-flex items-center w-full px-2 py-1 text-sm font-semibold transition-colors duration-150 rounded-md hover:bg-gray-100 hover:text-gray-800 dark:hover:bg-gray-800 dark:hover:text-gray-200">
                                        <svg
                                            class="w-4 h-4 mr-3"
                                            aria-hidden="true"
                                            fill="none"
                                            stroke-linecap="round"
                                            stroke-linejoin="round"
                                            stroke-width="2"
                                            viewBox="0 0 24 24"
                                            stroke="currentColor"
                                        >
                                            <path
                                                d="M11 16l-4-4m0 0l4-4m-4 4h14m-5 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h7a3 3 0 013 3v1"
                                            ></path>
                                        </svg>
                                        <span>Log out</span>
                                    </button>
                                </li>
                            </form>
                        </ul>
                    </transition>
                </li>
            </ul>
        </div>
    </header>
</template>

<script>
import {onClickOutside} from '@vueuse/core';

export default {
    name: "TopBar",
    props: {
        isSideMenuOpen: Boolean,
    },
    mounted() {
        onClickOutside(this.$refs.profileMenu, () => this.closeProfileMenu());
        onClickOutside(this.$refs.notificationMenu, () => this.closeNotificationsMenu());
        onClickOutside(this.$refs.teamsMenu, () => this.closeTeamsMenu());
    },
    data() {
        return {
            isNotificationsMenuOpen: false,
            isTeamsMenuOpen: false,
            isProfileMenuOpen: false,
        }
    },
    methods: {
        toggleSideMenu() {
            this.$emit('side-menu-toggle', !this.isSideMenuOpen);
        },
        toggleTheme() {
            this.dark = !this.dark;
            this.setThemeToLocalStorage(this.dark);
        },
        toggleNotificationsMenu() {
            this.isNotificationsMenuOpen = !this.isNotificationsMenuOpen
        },
        closeNotificationsMenu() {
            this.isNotificationsMenuOpen = false
        },
        toggleTeamsMenu() {
            this.isTeamsMenuOpen = !this.isTeamsMenuOpen
        },
        closeTeamsMenu() {
            this.isTeamsMenuOpen = false
        },
        toggleProfileMenu() {
            this.isProfileMenuOpen = !this.isProfileMenuOpen
        },
        closeProfileMenu() {
            this.isProfileMenuOpen = false
        },
        logout() {
            this.$inertia.post(route('logout'));
        },
        switchToTeam(team) {
            this.$inertia.put(route('current-team.update'), {
                'team_id': team.id
            }, {
                preserveState: false
            })
        },
    },
}
</script>

<style scoped>

</style>
